const Philosophy = () => {
  return (
    <section
      data-testid="philosophy-section"
      className="relative bg-[#FDFCFB] py-24 md:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-16">
        <div className="md:col-span-4">
          <p className="text-xs tracking-[0.35em] uppercase text-[#7B8E76] mb-6">
            The Approach
          </p>
          <h2 className="font-serif text-4xl md:text-5xl text-[#2D3A2B] leading-[1.1]">
            Balance & <span className="italic">Wellness</span>
          </h2>
          <div className="mt-8 h-px w-24 bg-[#C6A692]" aria-hidden />
        </div>
        <div className="md:col-span-8 space-y-8 text-[#4A5D46] font-light">
          <p className="text-xl md:text-2xl leading-relaxed font-serif text-[#2D3A2B]">
            Each of us has the capacity to express our unique qualities in
            healthy, balanced ways. We also all have patterns that can become
            imbalanced—often so gradually that we don&rsquo;t recognize them until
            they begin affecting our physical health, emotional wellbeing,
            relationships, or other areas of life.
          </p>
          <p className="text-lg leading-relaxed">
            Many of the qualities that are our greatest strengths can, when
            pushed to an extreme or left unsupported, become our greatest
            challenges. Likewise, what initially appears to be a challenge often
            contains the seed of a profound strength when brought back into
            balance.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
